module.exports = __webpack_public_path__ + "static/fonts/Nunito-Medium.f86d923.woff2";